/**
 * 認証ガード。
 *
 * `AdminAuthService` の状態が `signedIn` のときだけ管理画面を描く。
 * 「ログイン済みだが admins に無い」は service 側でサインアウト済みなので、
 * ここでは `signedOut + error` として通常のログイン画面にメッセージを出す。
 */
import { useEffect, useState } from 'react';
import { bootstrap } from './services/bootstrap';
import type { AdminState } from './services/adminAuth';
import { Console } from './ui/Console';
import { LoginScreen } from './ui/LoginScreen';

export function App() {
  const boot = bootstrap();
  const [state, setState] = useState<AdminState>(
    boot.kind === 'ready' ? boot.auth.current() : { kind: 'loading' },
  );

  useEffect(() => {
    if (boot.kind !== 'ready') return undefined;
    return boot.auth.subscribe(setState);
  }, [boot]);

  if (boot.kind === 'unconfigured') {
    return (
      <div className="login">
        <div className="login__card">
          <h1 className="login__title">設定が足りません</h1>
          <p className="login__sub">
            次の環境変数が設定されていないため起動できません(.env.example を参照)。
          </p>
          <ul className="mono">
            {boot.missing.map((key) => (
              <li key={key}>{key}</li>
            ))}
          </ul>
        </div>
      </div>
    );
  }

  if (state.kind === 'loading') {
    return (
      <div className="login">
        <p className="muted">読み込み中…</p>
      </div>
    );
  }

  if (state.kind === 'signedOut') {
    return (
      <LoginScreen
        auth={boot.auth}
        initialError={state.error}
        projectId={boot.projectId}
        usingEmulator={boot.usingEmulator}
      />
    );
  }

  return <Console boot={boot} session={state.session} />;
}
